import React from 'react';
import { useState } from "react";
import { useAuth, IAuth } from "../hooks/useAuth";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { HMChalet } from '../data/chaletapi';


export const LoginPage = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const { login }: IAuth = useAuth();
    const handleLogin = async (e: any) => {
        e.preventDefault();
        const loginreturn = await HMChalet.login(username,password)
        if (loginreturn) {
            login(username,loginreturn.token)
        } else {
            alert("Invalid username or password");
        }
    };
    return (
        
        <Container fluid className="login">
            <Row>
                <Col>
                    <Form onSubmit={handleLogin}>
                        <Form.Group className="mb-3" controlId="username">
                            <Form.Control onChange={(e) => setUsername(e.target.value)} type="string" placeholder="Enter Username" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Control onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Password" />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );


};